module.exports = __webpack_public_path__ + "resource/img/editIcon.3d91471c.svg";